import productsDictionary from '@entities/main-products/i18n/ru/products.dic.json';

export const products = {
  PRODUCTS: productsDictionary,
};

export const productsNamespaces = ['PRODUCTS'];
